<template>
  <div :class="`personal ${type == 'child' && !isMobile ? 'childPersonal' : ''}`">
    <div class="itemContentTitle">{{type == 'personal' ? `参观人（最多选择${maxPersonal}位）` : '儿童'}}</div>
    <div :class="`itemCard ${type == 'child' && !isMobile ? type : ''}`">
      <slot></slot>
      <div class="itemWarp" v-if="type == 'child'">
        <div class="contentTitle">是否携带儿童</div>
        <el-radio-group v-model="hasChild" :disabled="!maxChildNum" @change="selectedHasChild" :style="isMobile ? 'margin-top: 0.1rem' : ''">
          <el-radio :label="1">否</el-radio>
          <el-radio :label="2">是(最多{{maxChildNum}}位)</el-radio>
        </el-radio-group>
      </div>
      <div :class="`nameWarp ${type}`" v-if="type == 'personal' || (type == 'child' && hasChild == 2 && fillChildrenInfo) ">
        <div :class="`nameBlock ${!delPersonal && selectIndexs.indexOf(index) > -1 ? 'selected' : ''}`" v-for="(item, index) in datas" :key="item.id" @click="selectName(item, index)">
          {{item.personName}}
          <span v-if="delPersonal">-</span>
        </div>
        <div :class="`nameBlock add ${delPersonal ? 'saveDelData' : ''}`" @click="add">{{delPersonal ? '完成' : '+'}}</div>
        <div class="nameDetail" v-for="(item, index) in selectIndexs" :key="item">
          <div class="delName" @click="del(index)">一</div>
          <div>{{datas[item]?datas[item].personName : ''}}</div>
          <div v-if="type == 'personal'">{{datas[item]?datas[item].cardNum:''}}</div>
          <div v-else class="age">{{datas[item]?datas[item].age :''}}岁</div>
          <div class="buttonText" @click="edit(item)">编辑</div>
        </div>
      </div>
      <div v-if="type == 'child' && !fillChildrenInfo && hasChild == 2" class="lineContent childNumber">
        <div class="name">儿童人数</div>
        <el-input v-model="childNumber" placeholder="请输入儿童人数" type="number" @input="changeNumber"></el-input>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      selectIndexs: [],
      hasChild: 1,
      delPersonal: false,
      childNumber: ''
    };
  },

  props: ['type', 'datas', 'maxChildNum', 'maxPersonal', 'needPersonalVoucher', 'isMobile', 'fillChildrenInfo'],

  methods: {
    // 数量变化
    changeNumber(value) {
      if (value > parseInt(this.maxChildNum)){
        this.childNumber = this.maxChildNum
      }
      this.$emit('changeChildNumber', this.childNumber)
    },
    //点击姓名更换
    selectName(item, index) {
      if (this.delPersonal) {
        this.selectIndexs = []
        return this.$emit('delData', index, this.type)
      }
      let s_index = this.selectIndexs.indexOf(index)
      if (s_index > -1) { //已选
        return this.selectIndexs.splice(s_index, 1)
      }
      if (this.type == 'child' && this.selectIndexs.length == this.maxChildNum) {
        return this.$message.error('携带儿童数量已到最大值')
      }
      if (this.type == 'personal' && this.selectIndexs.length == this.maxPersonal) {
        return this.$message.error('选择的参观人数已到最大值')
      }
      this.selectIndexs.push(index)
    },

    edit(index) {
      this.$emit('editPersonal', index, this.type)
    },

    del(index) {
      this.selectIndexs.splice(index, 1)
    },

    add() {
      if (this.delPersonal) {
        this.selectIndexs = []
        return this.delPersonal = false
      }
      // if (this.datas.length >= 5) {
      //   alert('最多保存5位参观人，请先删除已存信息')
      //   return this.delPersonal = true
      // }
      this.$emit('handelShowAdd', true, this.type, 'add')
    },

    // 点击携带儿童
    selectedHasChild(val) {
      if (!val) return
      this.$emit('selectedHasChild', val)
    }
  },

  mounted() {
    if (this.type != 'personal') return
    this.selectIndexs.push(0)
  },

  created() {
  },

  computed: {
  
  },

  watch: {
    selectIndexs: {
      handler(val, oldVal) {
        console.log(val)
        this.$emit('changeSelectData', val, this.type)
      },
      deep:true //true 深度监听
    }
  }
}
</script>

<style scoped lang="scss">
  .nameWarp{
    .nameBlock {
      position: relative;
      span{
        position: absolute;
        top: 0;
        left: 0.06rem;
        line-height: 0.2rem;
        color: #990000;
        font-weight: 700;
        transform: scale(2)
      }
    }
    .saveDelData{
      font-size: 0.4rem;
      line-height: 1rem;
    }
    .age{
      margin-left: 0.6rem;
      width: 3.5rem;
    }
    &.child{
      margin-top: 0.3rem;
    }
  }
</style>
<style type="text/css" lang="scss">
  .pcContent{
    .nameWarp{
      .nameBlock{
        span{
          transform: scale(3);
          top: -0.05rem;
        }
      }
      .saveDelData{
        font-size: 0.15rem !important;
        line-height: 0.33rem;
      }
    }
    .childNumber{
      margin-top: -15px;
      padding-bottom: 20px;
      .name{
        font-size: 26px;
        width: 120px;
      }
      .el-input, .el-input__inner{
        width: 200px;
        font-size: 24px;
        text-align: left;
      }
    }
  }
  .childPersonal{
    margin-top: 40px;
    .itemCard.child{
      padding: 0 90px;
    }
    .itemWarp{
      padding: 30px 0;
    }
    .nameWarp.child{
      margin-top: -20px !important;
      padding-bottom: 30px;
    }
  }
</style>




